<h2 mat-dialog-title>Success!</h2>
<mat-dialog-content>
    <div style="display: flex; justify-content: center; align-items: center; gap: 50px; margin: 2rem 0 3rem 0">
        <img src="/img/jar.png" alt="Jar" style="width: 100px; height: 100px;">
        <app-icon icon="add" style="font-size: 50px;"></app-icon>
        <img src="/img/vrchat_icon.png" alt="VRChat" style="width: 100px; height: 100px;">
    </div>
    <div>Your <b>VRChat</b> account has been successfully connected to your profile.</div>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
